export interface SampleBuilding {
  id: string;
  name: string;
  description: string;
  thumbnailUrl: string;
  imageDataUrl: string;
  architecturalStyle: string;
}

// SVG Data URLs representing typical under-construction / unplastered Indian houses with scaffolding
const sample1Svg = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600" viewBox="0 0 800 600">
  <rect width="800" height="600" fill="%23d8cfc4"/>
  <!-- Sky -->
  <rect width="800" height="200" fill="%23bde0fe"/>
  <path d="M0,200 Q200,180 400,195 T800,200 L800,600 L0,600 Z" fill="%23c5baa8"/>
  <!-- Ground dirt/rubble -->
  <rect y="480" width="800" height="120" fill="%238a7968"/>
  <circle cx="150" cy="520" r="15" fill="%236e5f52"/>
  <circle cx="280" cy="540" r="22" fill="%23584b40"/>
  <rect x="500" y="500" width="80" height="40" fill="%23b85d38"/>
  
  <!-- Main Unplastered House Structure (Raw Red Brick & Grey Concrete Columns) -->
  <!-- Ground floor masonry -->
  <rect x="200" y="240" width="400" height="240" fill="%23b35431"/>
  <!-- Brick pattern lines -->
  <path d="M200,270 L600,270 M200,300 L600,300 M200,330 L600,330 M200,360 L600,360 M200,390 L600,390 M200,420 L600,420 M200,450 L600,450" stroke="%238f3f22" stroke-width="2"/>
  
  <!-- Concrete lintels and columns (Raw Grey Cement) -->
  <rect x="200" y="240" width="30" height="240" fill="%23918d88"/>
  <rect x="380" y="240" width="30" height="240" fill="%23918d88"/>
  <rect x="570" y="240" width="30" height="240" fill="%23918d88"/>
  <!-- Slab band -->
  <rect x="180" y="230" width="440" height="20" fill="%23a39e98"/>
  <rect x="180" y="350" width="440" height="15" fill="%23a39e98"/>
  <rect x="180" y="120" width="440" height="20" fill="%23a39e98"/>
  
  <!-- First floor unplastered brick -->
  <rect x="200" y="140" width="400" height="90" fill="%23c25e38"/>
  <path d="M200,160 L600,160 M200,180 L600,180 M200,200 L600,200 M200,220 L600,220" stroke="%238f3f22" stroke-width="2"/>
  <rect x="200" y="140" width="30" height="90" fill="%23918d88"/>
  <rect x="380" y="140" width="30" height="90" fill="%23918d88"/>
  <rect x="570" y="140" width="30" height="90" fill="%23918d88"/>

  <!-- Unfinished Empty Windows & Door Frame -->
  <rect x="250" y="270" width="90" height="120" fill="%233a3531"/>
  <rect x="440" y="270" width="100" height="180" fill="%232b2724"/>
  <rect x="250" y="150" width="80" height="60" fill="%233a3531"/>
  <rect x="450" y="150" width="80" height="60" fill="%233a3531"/>

  <!-- Metal & Bamboo Scaffolding Overlay (To be cleaned!) -->
  <g stroke="%23473f32" stroke-width="4" opacity="0.85">
    <!-- Vertical scaffolding pipes -->
    <line x1="160" y1="100" x2="160" y2="520"/>
    <line x1="230" y1="100" x2="230" y2="520"/>
    <line x1="320" y1="100" x2="320" y2="520"/>
    <line x1="410" y1="100" x2="410" y2="520"/>
    <line x1="500" y1="100" x2="500" y2="520"/>
    <line x1="620" y1="100" x2="620" y2="520"/>
    
    <!-- Horizontal scaffolding planks -->
    <line x1="140" y1="160" x2="640" y2="160" stroke-width="6" stroke="%23b8860b"/>
    <line x1="140" y1="260" x2="640" y2="260" stroke-width="6" stroke="%23b8860b"/>
    <line x1="140" y1="380" x2="640" y2="380" stroke-width="6" stroke="%23b8860b"/>
    
    <!-- Diagonal bracing wires -->
    <line x1="160" y1="160" x2="320" y2="260"/>
    <line x1="320" y1="160" x2="160" y2="260"/>
    <line x1="410" y1="260" x2="620" y2="380"/>
    <line x1="620" y1="260" x2="410" y2="380"/>
  </g>
  
  <!-- Construction ladder and electrical cables hanging -->
  <line x1="480" y1="260" x2="520" y2="480" stroke="%23e0a96d" stroke-width="5"/>
  <path d="M100,80 Q200,220 350,190 T600,140" fill="none" stroke="%231a1a1a" stroke-width="2"/>
  
  <!-- Labels -->
  <rect x="20" y="20" width="300" height="40" rx="8" fill="rgba(0,0,0,0.7)"/>
  <text x="35" y="45" fill="%23ffffff" font-family="sans-serif" font-size="16" font-weight="bold">Raw Unplastered Duplex House</text>
</svg>`;

const sample2Svg = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600" viewBox="0 0 800 600">
  <rect width="800" height="600" fill="%23c2c9d1"/>
  <!-- Sky -->
  <rect width="800" height="220" fill="%23a2d2ff"/>
  <!-- Unfinished Cement Villa -->
  <rect x="150" y="180" width="500" height="320" fill="%238d99ae"/>
  
  <!-- Grey AAC Concrete blocks texture -->
  <path d="M150,220 L650,220 M150,260 L650,260 M150,300 L650,300 M150,340 L650,340 M150,380 L650,380 M150,420 L650,420 M150,460 L650,460" stroke="%236c757d" stroke-width="2"/>
  <path d="M250,180 L250,500 M400,180 L400,500 M550,180 L550,500" stroke="%23495057" stroke-width="6"/>

  <!-- Unfinished balcony parapet & rebar sticking out -->
  <rect x="200" y="260" width="400" height="50" fill="%23adb5bd"/>
  <line x1="220" y1="260" x2="220" y2="230" stroke="%23495057" stroke-width="3"/>
  <line x1="280" y1="260" x2="280" y2="225" stroke="%23495057" stroke-width="3"/>
  <line x1="340" y1="260" x2="340" y2="235" stroke="%23495057" stroke-width="3"/>
  <line x1="400" y1="260" x2="400" y2="220" stroke="%23495057" stroke-width="3"/>
  <line x1="460" y1="260" x2="460" y2="230" stroke="%23495057" stroke-width="3"/>
  <line x1="520" y1="260" x2="520" y2="225" stroke="%23495057" stroke-width="3"/>
  
  <!-- Empty window openings -->
  <rect x="220" y="330" width="120" height="110" fill="%23212529"/>
  <rect x="460" y="330" width="120" height="110" fill="%23212529"/>
  <rect x="360" y="330" width="70" height="170" fill="%2315181b"/>

  <!-- Scaffolding bamboo poles -->
  <g stroke="%23854d0e" stroke-width="5">
    <line x1="120" y1="140" x2="120" y2="520"/>
    <line x1="260" y1="140" x2="260" y2="520"/>
    <line x1="400" y1="140" x2="400" y2="520"/>
    <line x1="540" y1="140" x2="540" y2="520"/>
    <line x1="680" y1="140" x2="680" y2="520"/>
    <line x1="100" y1="200" x2="700" y2="200" stroke-width="7"/>
    <line x1="100" y1="320" x2="700" y2="320" stroke-width="7"/>
    <line x1="100" y1="440" x2="700" y2="440" stroke-width="7"/>
  </g>

  <!-- Foreground cement mixer & sand heap -->
  <ellipse cx="680" cy="520" rx="70" ry="30" fill="%23e9ecef"/>
  <rect x="80" y="470" width="90" height="70" rx="10" fill="%23ffb703"/>

  <rect x="20" y="20" width="320" height="40" rx="8" fill="rgba(0,0,0,0.7)"/>
  <text x="35" y="45" fill="%23ffffff" font-family="sans-serif" font-size="16" font-weight="bold">AAC Concrete Block Modern Villa</text>
</svg>`;

export const SAMPLE_BUILDINGS: SampleBuilding[] = [
  {
    id: 'sample-brick-duplex',
    name: 'Unplastered Brick Duplex',
    description: 'Raw red brick structure with exposed concrete columns, scaffolding, and open window frames.',
    thumbnailUrl: sample1Svg,
    imageDataUrl: sample1Svg,
    architecturalStyle: 'Modern Indian Duplex',
  },
  {
    id: 'sample-block-villa',
    name: 'AAC Block Modern Villa',
    description: 'Grey concrete block building with steel rebar, bamboo scaffolding, and open ground floor.',
    thumbnailUrl: sample2Svg,
    imageDataUrl: sample2Svg,
    architecturalStyle: 'Contemporary Box Villa',
  },
];
